module.exports = __webpack_public_path__ + "static/media/icon_checkout.02770b0e.svg";